module.exports = __webpack_public_path__ + "media/images/live-bg-d1ed8e3a3e0cb5a6dd4d72f47dececf5.jpg";